export const isError = (formik, fieldName) => {
  if (formik.errors[fieldName]) {
    return formik.dirty
      ? formik.touched.hasOwnProperty(fieldName) && formik.touched[fieldName]
      : formik.touched.hasOwnProperty(fieldName);
  }
  return false;
};
